import { useToast } from 'vue-toastification';
import { translateAPIError } from '@/app/lang/translate-api-error.js';
import CFCustomToast from '@/shared/components/CFCustomToast.vue';
import Bugsnag from '@bugsnag/js';
import { isAxiosError } from 'axios';

let toast;

export function unexpectedError(error, fallback = undefined) {
    if (!toast) {
        toast = useToast();
    }

    const code = translateAPIError(error, fallback);

    // This is used for development, it gets filtered out in production
    console.warn(error);

    let requestId;

    if (error?.response?.status !== 422) {
        requestId = error?.response?.data?.errors?.[0]?.meta?.request_identifier;
    }

    // Report the error to Bugsnag if it's not coming from an error in Midplane
    if (!isAxiosError(error)) {
        Bugsnag.notify(error);
    }

    const toastContext = {
        component: CFCustomToast,
        props: {
            code,
            requestId,
        },
    };

    toast.error(toastContext);
}
